import SeleksiVendor from './SeleksiVendor'

export default SeleksiVendor